import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/sharp-solid-svg-icons/faPlus';

import { defineMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Text } from 'ui-components/components/text';

import style from './add-to-batch-menu.module.less';

const message = defineMessage({
  defaultMessage: 'Create New Batch',
  description: 'button that when clicked creates a new batch of orders',
  id: 'Dd9jDW',
});

export const CreateNewBatchButton = ({ createNewBatch, isAddingToBatch }) => {
  return (
    <Button className={style['create-new-batch-button']} disabled={isAddingToBatch} onClick={createNewBatch} theme='unstyled'>
      <div className={style['plus-icon']}>
        <FontAwesomeIcon icon={faPlus} />
      </div>
      <Text value={message} />
    </Button>
  );
};
